import { useNavigate } from 'react-router-dom'
import { IconArrowLeft } from '@/app/components/icons'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-tg-bg px-6 text-center animate-fade-in">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-tg-destructive/10">
        <span className="text-5xl font-bold text-tg-destructive">404</span>
      </div>
      <h1 className="mb-2 text-xl font-semibold text-tg-text">
        Page not found
      </h1>
      <p className="mb-8 text-sm text-tg-hint">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <button
        onClick={() => navigate('/')}
        className="group flex items-center gap-2 rounded-xl bg-tg-button px-6 py-3 text-sm font-semibold text-tg-button-text transition-all duration-200 active:scale-[0.98]"
      >
        <IconArrowLeft className="h-4 w-4 transition-transform group-active:-translate-x-0.5" />
        Go to Generate
      </button>
    </div>
  )
}
